import { render, staticRenderFns } from "./SaludOcupacionalSection.vue?vue&type=template&id=25f8032e&scoped=true&"
import script from "./SaludOcupacionalSection.vue?vue&type=script&lang=js&"
export * from "./SaludOcupacionalSection.vue?vue&type=script&lang=js&"
import style0 from "./SaludOcupacionalSection.vue?vue&type=style&index=0&id=25f8032e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f8032e",
  null
  
)

export default component.exports